import { requestJson } from "../../../../helpers/api";
import {
  CatalogosResponse,
  ClientInfo,
  SaasEmpresa,
  SaasSucursal,
  SaasTalonario,
} from "./constants";

export const obtenerCatalogos = () =>
  requestJson<CatalogosResponse>("/api/saas/catalogos");

export const listarEmpresas = () =>
  requestJson<SaasEmpresa[]>("/api/saas/empresas");

export const listarSucursales = (empresaId: number) =>
  requestJson<SaasSucursal[]>(`/api/saas/sucursales?empresaId=${empresaId}`);

export const listarClientes = () =>
  requestJson<ClientInfo[]>("/api/saas/clientes");

export const listarTalonarios = (empresaId: number, sucursalId?: number) => {
  const params = new URLSearchParams();
  if (sucursalId) {
    params.set("sucursalId", String(sucursalId));
  }
  const query = params.toString();
  return requestJson<SaasTalonario[]>(
    `/api/saas/empresas/${empresaId}/talonarios${query ? `?${query}` : ""}`,
  );
};

export const crearCliente = (payload: {
  documentoTipoId: number;
  documento: string;
  razonSocial: string;
  nombreFantasia?: string;
  email?: string;
  telefono?: string;
}) =>
  requestJson<ClientInfo>("/api/saas/clientes", {
    method: "POST",
    body: JSON.stringify({
      documentoTipoId: payload.documentoTipoId,
      documento: payload.documento,
      razonSocial: payload.razonSocial,
      nombreFantasia: payload.nombreFantasia ?? null,
      email: payload.email ?? null,
      telefono: payload.telefono ?? null,
    }),
  });

export type CrearFacturaPayload = {
  empresaId: number;
  sucursalId: number;
  clienteId: number;
  talonarioId: number;
  tipoComprobanteId: number;
  condicionVentaId: number;
  fechaEmision: string;
  moneda?: string;
  cotizacion?: number;
  observaciones?: string;
  items: Array<{
    productoId?: number | null;
    descripcion: string;
    unidadMedidaId: number;
    cantidad: number;
    precioUnitario: number;
    descuento?: number;
    impuestoId: number;
  }>;
  pagos: Array<{
    medioPagoId: number;
    monto: number;
    referencia?: string | null;
  }>;
};

export const crearFactura = (payload: CrearFacturaPayload) =>
  requestJson(`/api/saas/facturas`, {
    method: "POST",
    body: JSON.stringify(payload),
  });
